import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ExternalPageGuard implements CanActivate {

  constructor(
    private route: Router,
    private authService: AuthService
  ) { }

  canActivate(): boolean {
    const loggedIn = this.authService.isLoggedIn();
    if (loggedIn) {
      this.route.navigate(['dashboard']);
      return loggedIn;
    }

    return !loggedIn;
  }
}